export const filterUnique = (data, key) => {
    const uniques = [];
    for (const report of data) {
        const slug = report[key];
        if (uniques.indexOf(slug) < 0) {
            uniques.push(slug);
        }
    }
    return uniques;
};
export const uniques = (array) => {
    const uniques = [];
    for (const s of array) {
        if (uniques.indexOf(s) < 0) {
            uniques.push(s);
        }
    }
    return uniques;
};
export const uniquesWithCount = (data, key) => {
    const o = {};
    const uniques = [];
    for (const report of data) {
        const slug = report[key];
        if (uniques.indexOf(slug) < 0) {
            uniques.push(slug);
        }
    }
    for (const u of uniques) {
        o[u] = data.filter(d => d[key] == u).length;
    }
    return o;
};
export const filterUniqueGeoFeatures = (data, key) => {
    const uniques = [];
    for (const feature of data) {
        const slug = feature.properties[key];
        if (uniques.indexOf(slug) < 0) {
            uniques.push(slug);
        }
    }
    return uniques;
};
export const formatLines = (data, keyForLine, keyForValue, keyForLabel) => {
    // data = (EitiReport|EitiPayments)
    let readyForLines = [];
    for (const unique of filterUnique(data, keyForLine)) {
        const line = [];
        for (const year of filterUnique(data, "year").slice()) {
            const object = data.find((r) => r[keyForLine] == unique && r.year == year);
            const value = object != undefined ? object[keyForValue] : 0;
            const label = object != undefined || object != null ? object[keyForLabel] : "";
            if (label != null) {
                line.push({
                    label,
                    time: year,
                    value
                });
            }
        }
        readyForLines.push(line);
    }
    readyForLines = readyForLines.filter((line) => {
        let bool = false;
        const values = line.map(l => l.value);
        for (const v of values) {
            if (v != 0) {
                bool = true;
            }
        }
        return bool;
    });
    return readyForLines;
};
